class ExtendSectionAbout extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    _safeInit(() => this.initAbout03Cards());
    _safeInit(() => this.initAbout04());
    _safeInit(() => this.initAbout05());
  }

  initAbout03Cards() {
    const $about03 = $('[name="extend-about03"]');
    if (!$about03.length) return;
    this._registerSectionLoad(
      "extend_about03_cards",
      "extend-about03",
      "initAbout03Cards"
    );
    this._clearFlktyList("about03CardsFlktyList");
    this._flktyListObj.about03CardsFlktyList = [];
    $about03.each((index, element) => {
      const $timeline = $(element).find('[name="extend-about03-timeline"]');
      const $timelineItem = $(element).find(".ea03-timeline-item");
      const $cards = $(element).find('[name="extend-about03-cards"]');
      const flkty = new Flickity($cards.get(0), {
        cellAlign: "center",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
      });
      flkty.on("select", () => {
        $timeline.find(".selected").removeClass("selected");
        $timelineItem.eq(flkty.selectedIndex).addClass("selected");
      });
      $timelineItem.eq(0).addClass("selected");
      $timelineItem.on("click", function () {
        const $item = $(this);
        if ($item.hasClass("selected")) return;
        $timeline.find(".selected").removeClass("selected");
        $item.addClass("selected");
        flkty.select($timelineItem.index(this));
      });
      this._flktyListObj.about03CardsFlktyList.push(flkty);
    });
  }

  initAbout04() {
    // 重点检查
    const $about04Wrapper = $('[name="extend-about04-wrapper"]');
    if (!$about04Wrapper.length) return;
    $about04Wrapper.each((index) => this._initAbout04Item(index));
  }

  _initAbout04Item(elementIndex) {
    let lastScrollTop = 0;
    const debounce = new ExtendDebounce();
    $(window).on("scroll", () =>
      debounce(
        () =>
          this._onAbout04Scroll(
            elementIndex,
            lastScrollTop,
            (val) => (lastScrollTop = val)
          ),
        150
      )()
    );
  }

  _onAbout04Scroll(elementIndex, lastScrollTop, setLastScrollTop) {
    const $element = $('[name="extend-about04-wrapper"]').eq(elementIndex);
    if (!this._isDivInViewport($element)) return;
    const $topBlock = $element.find('[name="extend-about040-block-top"]');
    const $bottomBlock = $element.find('[name="extend-about04-block-bottom"]');
    const currentScrollTop = $(window).scrollTop();
    const elementOffsetTop = $element.offset().top;
    const elementHeight = $element.outerHeight();
    const topDistance = elementOffsetTop - currentScrollTop;
    const windowHeight = $(window).height();
    const isDown = currentScrollTop > lastScrollTop;
    setLastScrollTop(currentScrollTop);
    if (isDown && topDistance <= 200) {
      $topBlock.css({ transform: "translateY(-100%)" });
      $bottomBlock.css({ transform: "translateY(0)" });
    } else if (!isDown && topDistance > 50) {
      $topBlock.css({ transform: "translateY(0)" });
      $bottomBlock.css({ transform: "translateY(100%)" });
    }
  }

  initAbout05() {
    // 重点检查
    const $about05Wrapper = $('[name="extend-about05-wrapper"]');
    if (!$about05Wrapper.length) return;
    $about05Wrapper.each((index) => this._initAbout05Item(index));
  }

  _initAbout05Item(elementIndex) {
    const $element = $('[name="extend-about05-wrapper"]').eq(elementIndex);
    const $handle = $element.find('[name="extend-about05-handle"]');
    let blockActiveIndex = 0;
    const debounce = new ExtendDebounce();

    $handle.mouseenter(() => {
      $(window).on("wheel", _onWheel);
      _toggleScroll(false);
    });
    $handle.mouseleave(() => {
      $(window).off("wheel", _onWheel);
      _toggleScroll(true);
    });

    const _onWheel = (event) => {
      const dir = event.originalEvent.wheelDelta < 0 ? "down" : "up";
      debounce(() => _switchBlock(dir), 500)();
    };

    const _switchBlock = (type) => {
      const activeIndex = _getActiveIndex(type, blockActiveIndex);
      if (type === "up" && activeIndex === 0) _toggleScroll(true);
      else if (type === "down" && activeIndex === 2) _toggleScroll(true);
      if (activeIndex < 0) return;
      blockActiveIndex = activeIndex;
      const $el = $('[name="extend-about05-wrapper"]').eq(elementIndex);
      $el.find(".ea05-pc-block.active").removeClass("active");
      $el.find(".ea05-pc-block").eq(blockActiveIndex).addClass("active");
    };

    const _getActiveIndex = (type, nowIndex) => {
      if (type === "down")
        return nowIndex >= 0 && nowIndex <= 1 ? nowIndex + 1 : -1;
      if (type === "up")
        return nowIndex >= 1 && nowIndex <= 2 ? nowIndex - 1 : -1;
    };

    const _toggleScroll = (state) => {
      $("body").css("overflow", state ? "auto" : "hidden");
    };
  }
}
